module.exports = __webpack_public_path__ + "static/img/hello.9fb4c6b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navAssistant/hello.gif
// module id = 0r2Y
// module chunks = 66